import React, { Component } from 'react';
import style from './../../component/common/style/index.scss';
import { Tooltip } from './../../component/common/ToolTip/ToolTip';
import { sortAsc} from '../../common/utils/index'
const gradeScale = ['Maximum mark', 'Assessment objective', 'Year average', 'Group average'];
function groupRowclass(params) {

    return (gradeScale.some(item => params.value === item)) ? style.groupedRow : style.uIdcolumn;
}
function colSpanclass(params) {
    return (gradeScale.some(item => params.value === item)) ? 2 : 1;
}
function questioncellClassColorblind(params) {
    let value = params.data.questionPercentage;
    return (value <= 35 && params.data.type == "question") ? [style.raRedcolorblind, style.centerCls, style.fontCls].join(' ') : (value > 35 && value < 70 && params.data.type == "question") ? [style.raYellowcolorblind, style.centerCls, style.fontCls].join(' ') : [style.centerCls, style.fontCls].join(" ");
}
function questioncellClass(params) {
    let value = params.data.questionPercentage;
    return (value <= 35 && params.data.type == "question") ? [style.raRed, style.centerCls, style.fontCls].join(' ') : (value > 35 && value < 70 && params.data.type == "question") ? [style.raYellow, style.centerCls, style.fontCls].join(' ') : [style.centerCls, style.fontCls].join(" ");
}

let questionConfig = {
  columndef: [
      { headerName: "Question",
       unSortIcon: true,
        sortingOrder: ['asc', null],
         wrapText: true,
          autoHeight: true,
           field: "question",
            cellClass: [style.fontCls].join(" "),
             sortable: true,
              minWidth: 140,
              cellRenderer: (params) => {
                  return `<span style="text-align:left;">${params.value}</span>`;
              } },
      { headerName: "Mark", field: "mark", unSortIcon: true, sortingOrder: ['asc'],sortable: true, minWidth: 70 , cellClass: [style.centerCls, style.fontCls].join(" "), },
      { headerName: "Group average mark", unSortIcon: true, sortingOrder: ['asc'], field: "avgScore", cellClass: [style.centerCls, style.fontCls].join(" "), sortable: true, minWidth: 200 },
            { headerName: "Topic",
             field: "topic",
              cellClass: [ style.fontCls].join(" "),
               sortable: true, 
               minWidth: 110,
               unSortIcon: true,
                sortingOrder: ['asc'],
                wrapText: true,
                autoHeight: true,
              cellRenderer: (params) => {

                  let topics = params.data.topic;
                   let tpldata = '';
                   if (topics) {
                       let topiclength =(topics.length-1)
                       topics.map((data, index) => {
                           name = data;
                           let comma = (index<topiclength)?",":"";
                           tpldata = tpldata + '<span>' + name + comma+'</span> ';
                       });

                       return tpldata;

                   }


               } },
            { headerName: "Strand",
             field: "strand",
              cellClass: [ style.fontCls].join(" "), 
              sortable: true,
               minWidth: 110,
               unSortIcon: true,
               sortingOrder: ['asc'],
               wrapText: true,
               autoHeight: true,
               cellRenderer: (params) => {

                   let strands = params.data.strand;
                   let tpldata = '';
                   if (strands) {
                       let strandslength = (strands.length-1)
                       strands.map((data, index) => {
                           name = data;
                           let comma = (index < strandslength) ? "," : "";
                           tpldata = tpldata + '<span>' + name + comma+'</span> ';
                       });

                       return tpldata;

                   }


               }  },
            { headerName: "Skill",
             field: "skills",
              cellClass: [style.fontCls].join(" "),
               sortable: true, 
               minWidth: 110,
               unSortIcon: true,
               sortingOrder: ['asc'],
               wrapText: true,
               autoHeight: true,
               cellRenderer: (params) => {

                   let skills = params.data.skills;
                   let tpldata = '';
                   if (skills) {
                       let skillslength = (skills.length-1)
                       skills.map((data, index) => {
                           name = data;
                           let comma = (index < skillslength) ? "," : "";
                           tpldata = tpldata + '<span>' + name +comma+ '</span> ';
                       });

                       return tpldata;

                   }


               } },
            { headerName: "Assessment objective", 
            field: "objectives", 
            cellClass: [style.fontCls].join(" "),
             sortable: true, 
             minWidth: 220,
             unSortIcon: true,
             sortingOrder: ['asc'],
             wrapText: true,
             autoHeight: true,
             cellRenderer: (params) => {

                 let objectives = params.data.objectives;
                 let tpldata = '';
                 if (objectives) {
                     let objectiveslength = (objectives.length-1);
                     objectives.map((data, index) => {
                         name = data;
                         let comma = (index < objectiveslength) ? "," : "";
                         tpldata = tpldata + '<span style="text-align: start">' + name +comma+ '</span> ';
                     });

                     return tpldata;

                 }


             } }
  ]  
};

export default questionConfig;

function customTooltip(tooltip) {

    return Tooltip(tooltip);
}

export const convertColumndef = (isColorblind, questionConfig) => {  
    let columnArray =[];
    questionConfig['columndef'].map((column)=>{
        if (column.field=='mark'){
            column.cellClass = (isColorblind) ? questioncellClassColorblind : questioncellClass;
        }
        columnArray.push(column)
    }) 
    return columnArray;
}

export const convertRowData = (questionConfig) => {
    let rowsArray = [],
     pinnedRow=[];
    if (questionConfig['rowData'].length>0){
        pinnedRow.push({ question: 'Total', mark: questionConfig['rowData'][0].assessmentMarks + '/' + questionConfig['rowData'][0].assessmentMaxMarks, avgScore: questionConfig['rowData'][0].assessmentAvgMarks + '/' + questionConfig['rowData'][0].assessmentMaxMarks, type: "total" });
    }    
    questionConfig['rowData'].map((data)=>{
        let lengthArray=[];
       
        lengthArray = [data.topic.length, data.strand.length, data.objectives.length, data.skills.length];
      
        let length = Math.max(...lengthArray);
        data.mark = data.questionScore + '/' + data.questionMaxScore;
        data.avgScore = data.questionAvgScore; 
        data.question = data.questionShortTitle + " : " + data.questionDescription;      
        data.type='question'
        rowsArray.push(data);
    })
    
    let rowData = sortAsc(rowsArray, 'questionOrder')
   return { rowData: rowData, pinnedData: pinnedRow};
}
